import { gsap } from "gsap";
import { deviceBrowserCheck } from "./deviceBrowserCheck.js";
export function cursorFollowInit() {
  const cursor = document.querySelector(".a_cursor");
  if (!cursor) return;
  const { isMobileOrTablet } = deviceBrowserCheck(); // ← 判定を取得
  if (!isMobileOrTablet)  {
    // PCの場合の処理
    const rect = cursor.getBoundingClientRect();
    const halfW = rect.width / 2;
    const halfH = rect.height / 2;

    window.addEventListener("mousemove", (e) => {
      gsap.to(cursor, {
        x: e.clientX - halfW,
        y: e.clientY - halfH,
        duration: 0.3,
        ease: "power2.out",
      });
    });
  } else {
    // モバイル・タブレットの場合の処理
  }
}